import { PageHeaderProvider } from "@mcleod/common";

export class ImagingPageHeaderProvider extends PageHeaderProvider {
    public override shouldDisplayUserSettings(): boolean {
        return false;
    }
}
